/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  TenantResponse,
  WebApiAdminDtoAdminDashboardDto,
  WebApiAdminDtoCompanyInvoiceDto,
  WebApiAdminDtoCreateUserDto,
  WebApiAdminDtoInvoiceFormDefaultsDto,
  WebApiAdminDtoInvoiceGenerationRequest,
  WebApiAdminDtoSetInvoiceStatusDto,
  WebApiAdminDtoSetLoginFailedCountDto,
  WebApiAdminDtoSetSubscriptionDto,
  WebApiAdminDtoSetUserAsAdminDto,
  WebApiAdminDtoSetUserPasswordDto,
  WebApiAdminDtoUserListResultDto,
  WebApiIntegrationsDtoAdminPingPaymentFeeReportDto,
  WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest,
  WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto,
} from '../models';
import {
    TenantResponseFromJSON,
    TenantResponseToJSON,
    WebApiAdminDtoAdminDashboardDtoFromJSON,
    WebApiAdminDtoAdminDashboardDtoToJSON,
    WebApiAdminDtoCompanyInvoiceDtoFromJSON,
    WebApiAdminDtoCompanyInvoiceDtoToJSON,
    WebApiAdminDtoCreateUserDtoFromJSON,
    WebApiAdminDtoCreateUserDtoToJSON,
    WebApiAdminDtoInvoiceFormDefaultsDtoFromJSON,
    WebApiAdminDtoInvoiceFormDefaultsDtoToJSON,
    WebApiAdminDtoInvoiceGenerationRequestFromJSON,
    WebApiAdminDtoInvoiceGenerationRequestToJSON,
    WebApiAdminDtoSetInvoiceStatusDtoFromJSON,
    WebApiAdminDtoSetInvoiceStatusDtoToJSON,
    WebApiAdminDtoSetLoginFailedCountDtoFromJSON,
    WebApiAdminDtoSetLoginFailedCountDtoToJSON,
    WebApiAdminDtoSetSubscriptionDtoFromJSON,
    WebApiAdminDtoSetSubscriptionDtoToJSON,
    WebApiAdminDtoSetUserAsAdminDtoFromJSON,
    WebApiAdminDtoSetUserAsAdminDtoToJSON,
    WebApiAdminDtoSetUserPasswordDtoFromJSON,
    WebApiAdminDtoSetUserPasswordDtoToJSON,
    WebApiAdminDtoUserListResultDtoFromJSON,
    WebApiAdminDtoUserListResultDtoToJSON,
    WebApiIntegrationsDtoAdminPingPaymentFeeReportDtoFromJSON,
    WebApiIntegrationsDtoAdminPingPaymentFeeReportDtoToJSON,
    WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestFromJSON,
    WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestToJSON,
    WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoFromJSON,
    WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoToJSON,
} from '../models';

export interface ApiAdminCreateUserPostRequest {
    webApiAdminDtoCreateUserDto?: WebApiAdminDtoCreateUserDto;
}

export interface ApiAdminDeleteAllMemberFieldsDeleteRequest {
    companyId?: number;
}

export interface ApiAdminDeleteAllMembersDeleteRequest {
    companyId?: number;
}

export interface ApiAdminDownloadInvoicePdfGetRequest {
    invoiceId?: number;
}

export interface ApiAdminGenerateInvoicePdfPostRequest {
    webApiAdminDtoInvoiceGenerationRequest?: WebApiAdminDtoInvoiceGenerationRequest;
}

export interface ApiAdminGetInvoiceFormDefaultsGetRequest {
    companyId?: number;
}

export interface ApiAdminGetPingPaymentFeeReportGetRequest {
    fromDate?: Date;
    toDate?: Date;
}

export interface ApiAdminGetPingPaymentFeeReportPdfGetRequest {
    fromDate?: Date;
    toDate?: Date;
}

export interface ApiAdminSetInvoiceStatusPostRequest {
    webApiAdminDtoSetInvoiceStatusDto?: WebApiAdminDtoSetInvoiceStatusDto;
}

export interface ApiAdminSetLoginFailedCountPostRequest {
    webApiAdminDtoSetLoginFailedCountDto?: WebApiAdminDtoSetLoginFailedCountDto;
}

export interface ApiAdminSetNewSubscriptionLevelPostRequest {
    companyId?: number;
    webApiAdminDtoSetSubscriptionDto?: WebApiAdminDtoSetSubscriptionDto;
}

export interface ApiAdminSetUserAsAdminPostRequest {
    webApiAdminDtoSetUserAsAdminDto?: WebApiAdminDtoSetUserAsAdminDto;
}

export interface ApiAdminSetUserPasswordPostRequest {
    webApiAdminDtoSetUserPasswordDto?: WebApiAdminDtoSetUserPasswordDto;
}

export interface ApiAdminUpdateTenantPutRequest {
    webApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest?: WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Creates a new active user account and company without sending activation email.
     */
    async apiAdminCreateUserPostRaw(requestParameters: ApiAdminCreateUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/CreateUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoCreateUserDtoToJSON(requestParameters.webApiAdminDtoCreateUserDto),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Creates a new active user account and company without sending activation email.
     */
    async apiAdminCreateUserPost(requestParameters: ApiAdminCreateUserPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.apiAdminCreateUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the admin dashboard with system overview, integration status, batch jobs, and error logs
     */
    async apiAdminDashboardGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiAdminDtoAdminDashboardDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/Dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiAdminDtoAdminDashboardDtoFromJSON(jsonValue));
    }

    /**
     * Gets the admin dashboard with system overview, integration status, batch jobs, and error logs
     */
    async apiAdminDashboardGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiAdminDtoAdminDashboardDto> {
        const response = await this.apiAdminDashboardGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async apiAdminDeleteAllMemberFieldsDeleteRaw(requestParameters: ApiAdminDeleteAllMemberFieldsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/DeleteAllMemberFields`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiAdminDeleteAllMemberFieldsDelete(requestParameters: ApiAdminDeleteAllMemberFieldsDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminDeleteAllMemberFieldsDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async apiAdminDeleteAllMembersDeleteRaw(requestParameters: ApiAdminDeleteAllMembersDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/DeleteAllMembers`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiAdminDeleteAllMembersDelete(requestParameters: ApiAdminDeleteAllMembersDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminDeleteAllMembersDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Streams a previously generated invoice PDF from blob storage. The blob container is private,  so the PDF is downloaded here and returned through the API rather than linked to directly.
     */
    async apiAdminDownloadInvoicePdfGetRaw(requestParameters: ApiAdminDownloadInvoicePdfGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.invoiceId !== undefined) {
            queryParameters['invoiceId'] = requestParameters.invoiceId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/DownloadInvoicePdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Streams a previously generated invoice PDF from blob storage. The blob container is private,  so the PDF is downloaded here and returned through the API rather than linked to directly.
     */
    async apiAdminDownloadInvoicePdfGet(requestParameters: ApiAdminDownloadInvoicePdfGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminDownloadInvoicePdfGetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiAdminGenerateInvoicePdfPostRaw(requestParameters: ApiAdminGenerateInvoicePdfPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GenerateInvoicePdf`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoInvoiceGenerationRequestToJSON(requestParameters.webApiAdminDtoInvoiceGenerationRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAdminGenerateInvoicePdfPost(requestParameters: ApiAdminGenerateInvoicePdfPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminGenerateInvoicePdfPostRaw(requestParameters, initOverrides);
    }

    /**
     * Gets all OneFront users
     */
    async apiAdminGetAllUsersGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiAdminDtoUserListResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GetAllUsers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiAdminDtoUserListResultDtoFromJSON(jsonValue));
    }

    /**
     * Gets all OneFront users
     */
    async apiAdminGetAllUsersGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiAdminDtoUserListResultDto> {
        const response = await this.apiAdminGetAllUsersGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all recorded customer invoices, newest first.
     */
    async apiAdminGetCustomerInvoicesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiAdminDtoCompanyInvoiceDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GetCustomerInvoices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiAdminDtoCompanyInvoiceDtoFromJSON));
    }

    /**
     * Gets all recorded customer invoices, newest first.
     */
    async apiAdminGetCustomerInvoicesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiAdminDtoCompanyInvoiceDto>> {
        const response = await this.apiAdminGetCustomerInvoicesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets the suggested next invoice number and the customer reference details from the company\'s most recent invoice, if any.
     */
    async apiAdminGetInvoiceFormDefaultsGetRaw(requestParameters: ApiAdminGetInvoiceFormDefaultsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiAdminDtoInvoiceFormDefaultsDto>> {
        const queryParameters: any = {};

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GetInvoiceFormDefaults`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiAdminDtoInvoiceFormDefaultsDtoFromJSON(jsonValue));
    }

    /**
     * Gets the suggested next invoice number and the customer reference details from the company\'s most recent invoice, if any.
     */
    async apiAdminGetInvoiceFormDefaultsGet(requestParameters: ApiAdminGetInvoiceFormDefaultsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiAdminDtoInvoiceFormDefaultsDto> {
        const response = await this.apiAdminGetInvoiceFormDefaultsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OneFront\'s Ping Payments service-fee report across all companies, filtered on the Ping  disbursement date. Intended as a bookkeeping voucher.
     */
    async apiAdminGetPingPaymentFeeReportGetRaw(requestParameters: ApiAdminGetPingPaymentFeeReportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiIntegrationsDtoAdminPingPaymentFeeReportDto>> {
        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = (requestParameters.fromDate as any).toISOString();
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = (requestParameters.toDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GetPingPaymentFeeReport`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiIntegrationsDtoAdminPingPaymentFeeReportDtoFromJSON(jsonValue));
    }

    /**
     * OneFront\'s Ping Payments service-fee report across all companies, filtered on the Ping  disbursement date. Intended as a bookkeeping voucher.
     */
    async apiAdminGetPingPaymentFeeReportGet(requestParameters: ApiAdminGetPingPaymentFeeReportGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiIntegrationsDtoAdminPingPaymentFeeReportDto> {
        const response = await this.apiAdminGetPingPaymentFeeReportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Same report as M:WebApi.Controllers.AdminController.GetPingPaymentFeeReportAsync(System.Nullable{System.DateTime},System.Nullable{System.DateTime}), rendered as a PDF.
     */
    async apiAdminGetPingPaymentFeeReportPdfGetRaw(requestParameters: ApiAdminGetPingPaymentFeeReportPdfGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['fromDate'] = (requestParameters.fromDate as any).toISOString();
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['toDate'] = (requestParameters.toDate as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GetPingPaymentFeeReportPdf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Same report as M:WebApi.Controllers.AdminController.GetPingPaymentFeeReportAsync(System.Nullable{System.DateTime},System.Nullable{System.DateTime}), rendered as a PDF.
     */
    async apiAdminGetPingPaymentFeeReportPdfGet(requestParameters: ApiAdminGetPingPaymentFeeReportPdfGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminGetPingPaymentFeeReportPdfGetRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the Ping Payments tenant configuration (e.g. refund callback URL)
     */
    async apiAdminGetTenantGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/GetTenant`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantResponseFromJSON(jsonValue));
    }

    /**
     * Updates the Ping Payments tenant configuration (e.g. refund callback URL)
     */
    async apiAdminGetTenantGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantResponse> {
        const response = await this.apiAdminGetTenantGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates the status of a recorded invoice (e.g. marking it as paid).
     */
    async apiAdminSetInvoiceStatusPostRaw(requestParameters: ApiAdminSetInvoiceStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/SetInvoiceStatus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoSetInvoiceStatusDtoToJSON(requestParameters.webApiAdminDtoSetInvoiceStatusDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the status of a recorded invoice (e.g. marking it as paid).
     */
    async apiAdminSetInvoiceStatusPost(requestParameters: ApiAdminSetInvoiceStatusPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminSetInvoiceStatusPostRaw(requestParameters, initOverrides);
    }

    /**
     * Sets a user\'s LoginFailedCount (e.g. to unlock an account locked out by too many failed login attempts).
     */
    async apiAdminSetLoginFailedCountPostRaw(requestParameters: ApiAdminSetLoginFailedCountPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/SetLoginFailedCount`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoSetLoginFailedCountDtoToJSON(requestParameters.webApiAdminDtoSetLoginFailedCountDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets a user\'s LoginFailedCount (e.g. to unlock an account locked out by too many failed login attempts).
     */
    async apiAdminSetLoginFailedCountPost(requestParameters: ApiAdminSetLoginFailedCountPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminSetLoginFailedCountPostRaw(requestParameters, initOverrides);
    }

    /**
     * 
     */
    async apiAdminSetNewSubscriptionLevelPostRaw(requestParameters: ApiAdminSetNewSubscriptionLevelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.companyId !== undefined) {
            queryParameters['companyId'] = requestParameters.companyId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/SetNewSubscriptionLevel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoSetSubscriptionDtoToJSON(requestParameters.webApiAdminDtoSetSubscriptionDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     */
    async apiAdminSetNewSubscriptionLevelPost(requestParameters: ApiAdminSetNewSubscriptionLevelPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminSetNewSubscriptionLevelPostRaw(requestParameters, initOverrides);
    }

    /**
     * Set user
     */
    async apiAdminSetUserAsAdminPostRaw(requestParameters: ApiAdminSetUserAsAdminPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/SetUserAsAdmin`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoSetUserAsAdminDtoToJSON(requestParameters.webApiAdminDtoSetUserAsAdminDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiServicesDataTransferObjectsUserServiceAuthenticateResDtoFromJSON(jsonValue));
    }

    /**
     * Set user
     */
    async apiAdminSetUserAsAdminPost(requestParameters: ApiAdminSetUserAsAdminPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiServicesDataTransferObjectsUserServiceAuthenticateResDto> {
        const response = await this.apiAdminSetUserAsAdminPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets a new password for a user, bypassing the self-service email reset flow.
     */
    async apiAdminSetUserPasswordPostRaw(requestParameters: ApiAdminSetUserPasswordPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/SetUserPassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiAdminDtoSetUserPasswordDtoToJSON(requestParameters.webApiAdminDtoSetUserPasswordDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Sets a new password for a user, bypassing the self-service email reset flow.
     */
    async apiAdminSetUserPasswordPost(requestParameters: ApiAdminSetUserPasswordPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAdminSetUserPasswordPostRaw(requestParameters, initOverrides);
    }

    /**
     * Updates the Ping Payments tenant configuration (e.g. refund callback URL)
     */
    async apiAdminUpdateTenantPutRaw(requestParameters: ApiAdminUpdateTenantPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/Admin/UpdateTenant`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequestToJSON(requestParameters.webApiPaymentRepositoryPingPaymentsDtoTenantUpdateTenantRequest),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Updates the Ping Payments tenant configuration (e.g. refund callback URL)
     */
    async apiAdminUpdateTenantPut(requestParameters: ApiAdminUpdateTenantPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiAdminUpdateTenantPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
